import Image from "next/image";
import React from "react";
import BgButton from "../buttons/BgButton";
import AgeIcon from "./AgeIcon";
import { ProjectType } from "@/app/types/projectTypes";
import { Link } from "@/app/config/navigation";
import { colors } from "@/app/constants";
import { useTranslations } from "next-intl";

function ProjectCard({ project, index }: ProjectCardType) {
  const color = colors[index % colors.length];
  const t = useTranslations("projects");

  return (
    <div className="rounded-[20px]  m-auto flex flex-col w-[293px] flex-shrink-0 lg:w-full lg:h-full  bg-white text-primary shadow-project">
      <div className="rounded-[20px]  h-[140px] lg:h-[13.1rem] overflow-hidden">
        <Image
          alt={project.projectName}
          width={430}
          height={210}
          className="w-full h-full object-cover"
          src={project.imageUrl}
        />
      </div>
      <div className="  lg:pb-[1.5rem] lg:pt-[1.5rem] px-[26px]  pb-[30px] lg:px-[2rem] pt-[19px] flex-1 flex flex-col">
        <h6
          className="text-[18px] flex-1  pb-5 lg:text-[1.75rem] font-bold text-secondary "
          style={{ color: color }}
        >
          {project.projectName}
        </h6>
        <div className="flex  gap-[16px] ">
          <div className="w-[48px] relative  h-[48px] rounded-full ">
            <Image
              src={project.studentIconUrl}
              alt={project.studentName}
              width={48}
              height={48}
              className="w-full h-full rounded-full relative z-10 object-cover "
            />
            <div
              className="w-full h-full z-0 rounded-full bg-secondary absolute left-[-3px]  top-[2px] "
              style={{ background: color }}
            ></div>
          </div>
          <div>
            <p className="text-[16px] lg:text-[1.25rem] font-bold">
              {project.studentName}
            </p>
            <div className="flex items-center gap-2 text-[12px] lg:text-[1.12rem]">
              <AgeIcon color={color} />
              <span>
                {project.studentAge} {t("years")}
              </span>
            </div>
          </div>
        </div>
        <div className="flex-1 py-6 ">
          <p className="text-[12px] line-clamp-4   lg:text-[1.12rem] font-[500]  lg:leading-[24px] leading-[18px]">
            {project.shortDescription}
          </p>
        </div>

        <Link
          href={`/projects/${project.id}`}
          className="mt-auto w-[200px] lg:w-full m-auto"
        >
          <div className="text-center">
            {" "}
            <BgButton className={`w-full`}>{t("view_project")}</BgButton>
          </div>
        </Link>
      </div>
    </div>
  );
}

export default ProjectCard;
type ProjectCardType = {
  color?: string;
  project: ProjectType;
  index: number;
};
